module.exports = __webpack_public_path__ + "static/media/SnJArcHomeDesktop.f3616cee.png";